(function () {
  'use strict';

  if (window.PramoghFilterDrawerInitialized) {
    return;
  }

  window.PramoghFilterDrawerInitialized = true;


  function getDrawer() {
    return document.getElementById(
      'pramogh-filter-drawer'
    );
  }


  function getOverlay() {
    return document.getElementById(
      'pramogh-filter-overlay'
    );
  }


  function openDrawer() {

    const drawer = getDrawer();
    const overlay = getOverlay();

    if (!drawer) {
      console.error(
        'PRAMOGH FILTER: Drawer not found.'
      );
      return;
    }


    drawer.classList.add(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );


    if (overlay) {

      overlay.classList.add(
        'is-open'
      );

      overlay.setAttribute(
        'aria-hidden',
        'false'
      );

    }


    document.body.classList.add(
      'pramogh-filter-open'
    );

  }


  function closeDrawer() {

    const drawer = getDrawer();
    const overlay = getOverlay();


    if (drawer) {

      drawer.classList.remove(
        'is-open'
      );

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    if (overlay) {

      overlay.classList.remove(
        'is-open'
      );

      overlay.setAttribute(
        'aria-hidden',
        'true'
      );

    }


    document.body.classList.remove(
      'pramogh-filter-open'
    );

  }


  document.addEventListener(
    'click',
    function (event) {

      const openButton =
        event.target.closest(
          '[data-pramogh-filter-open]'
        );


      if (openButton) {

        event.preventDefault();

        event.stopPropagation();

        openDrawer();

        return;

      }


      const closeButton =
        event.target.closest(
          '[data-filter-drawer-close]'
        );


      if (closeButton) {

        event.preventDefault();

        closeDrawer();

        return;

      }


            const overlay =
        event.target.closest(
          '[data-filter-overlay]'
        );


      if (overlay) {

        event.preventDefault();

        closeDrawer();

        return;

      }


      const applyButton =
        event.target.closest(
          '#pramogh-filter-drawer .facets__apply, ' +
          '#pramogh-filter-drawer #filter__apply-all'
        );


      if (applyButton) {

        closeDrawer();

      }

    },
    true
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {

        closeDrawer();

      }

    }
  );


})();